import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { map } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-section-services',
  template: `
    <app-navigation-menu-list
      [list]="servicesList$ | flAsync"
      [marginBottomTablet]="'xxsmall'"
    >
    </app-navigation-menu-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionServicesComponent {
  private featureFlagsService = inject(FeatureFlagsService);
  servicesList = [
    {
      linkDescription: $localize`Preferred Freelancer Program`,
      linkUrl: '/preferred-freelancer-program',
    },
    {
      linkDescription: $localize`Verified by Freelancer`,
      linkUrl: '/verified',
    },
    {
      linkDescription: $localize`Project management`,
      linkUrl: '/project-management',
    },
    {
      linkDescription: $localize`Recruiter`,
      linkUrl: '/recruiter',
    },
    {
      linkDescription: $localize`Memberships`,
      linkUrl: '/membership',
    },
  ];

  servicesList$ = this.featureFlagsService
    .getFlag(Feature.FREELANCER_VERIFIED)
    .pipe(
      map(flagEnabled =>
        flagEnabled
          ? this.servicesList
          : this.servicesList.filter(t => t.linkUrl !== '/verified'),
      ),
    );
}
